@if (getFilters$ | async; as filters) {
    <div class="category-filter">
        @if ((isMobile$ | async) === false && isBrowser) {
            @if (filtersProduct$ | async; as mapFilters) {
                <div class="swiper swiper-filter category-filter-badgets {{ swiperFiltersClass }}">
                    <div class="swiper-wrapper">
                        @for (filter of mapFilters | keyvalue; track $index) {
                            <div class="swiper-slide">
                                <div class="filter-badge align-items-center ttu text-l blend-link">
                                    <div class="leading-1">
                                        {{ filter.key === '01' ? ('dev.product.oneSize' | translate) : filter.key }}
                                    </div>
                                    <button type="button" class="link-raw ml-8 icon-white" (click)="removeFilter(filters, filter.value)">
                                        <md-icon name="close-s"></md-icon>
                                    </button>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            }
        } @else {
            @if (filtersProduct$ | async; as mapFilters) {
                <div class="category-filter-badgets">
                    @for (filter of mapFilters | keyvalue; track $index) {
                        <span class="filter-badge align-items-center ttu text-l">
                            <div class="leading-1 blend-link">
                                {{ filter.key === '01' ? ('dev.product.oneSize' | translate) : filter.key }}
                            </div>
                            <button type="button" class="link-raw ml-8 icon-white" (click)="removeFilter(filters, filter.value)">
                                <md-icon name="close-s"></md-icon>
                            </button>
                        </span>
                    }
                </div>
            }
        }
    </div>
}
